<template>
  <InputNumber class="ts-input-number" size="mini" v-bind="$attrs" v-on="$listeners" />
</template>

<style lang="scss" scoped>
.ts-input-number::v-deep {
  .el-input__inner {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    box-shadow: inset -3px -3px 5px 0 #fafbff, inset 3px 3px 5px 0 #a6abbd;

    font-family: Roboto;
    color: #242424;

    &:focus {
      border-color: #99ffd1;
    }
  }

  .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled),
  .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled) {
    border-color: #99ffd1;
  }

  .el-input-number__decrease:hover,
  .el-input-number__increase:hover {
    color: #99ffd1;
  }
}
</style>

<script>
import { InputNumber } from 'element-ui';

export default {
  name: 'TsInputNumber',
  components: {
    InputNumber
  }
};
</script>
